import React, { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination'

import './PaginationWidget.css';

class PaginationWidget extends Component {

    buildPagination = (count, offset, quantity) => {
        let pagination = "";
        const pages = Math.ceil(count/quantity);
        const offsetPage = Math.ceil(offset/quantity);
        const spread = 3;

        for (let i=1; i<=pages; i++) {
            //Set active page class
            let active = (Math.floor(offset/quantity) === i-1);
            //Build Pagination with ... if there are more than 'spread' elements between the first, active, and last pages
            if (i<spread) {
                pagination = (<>{pagination}<Pagination.Item onClick={ () => {this.props.updatePage(((i-1) * quantity))}} active={active}>{i}</Pagination.Item></>);
            } else if ((pages - i) < spread ) {
                pagination = (<>{pagination}<Pagination.Item onClick={ () => {this.props.updatePage(((i-1) * quantity))}} active={active}>{i}</Pagination.Item></>);
            } else if ( (i > offsetPage - spread) && (i < offsetPage + spread) && (!i<spread) && (!(pages - i) < spread) ) {
                pagination = (<>{pagination}<Pagination.Item onClick={ () => {this.props.updatePage(((i-1) * quantity))}} active={active}>{i}</Pagination.Item></>);
            } else {
                if (i === spread) {
                    pagination = (<>{pagination}<Pagination.Ellipsis disabled/></>);
                }
                if ((pages - i) === spread) {
                    pagination = (<>{pagination}<Pagination.Ellipsis disabled /></>);
                }
            }
        }

        return pagination;
    };

    render () {
        let previous_page = 0;
        if(this.props.offset > this.props.quantity) {
            previous_page = this.props.offset - this.props.quantity;
        }
        const last_page = (Math.ceil(this.props.count/this.props.quantity)-1)*this.props.quantity;
        let next_page = this.props.offset;
        if(next_page < last_page) {
            next_page = this.props.offset + this.props.quantity;
        }

        return (
            <Pagination>
                <Pagination.First onClick={ () => {this.props.updatePage(0)}} />
                <Pagination.Prev onClick={ () => {this.props.updatePage(previous_page)}} />
                {this.buildPagination(this.props.count, this.props.offset, this.props.quantity)}
                <Pagination.Next onClick={ () => {this.props.updatePage(next_page)}}/>
                <Pagination.Last onClick={ () => {this.props.updatePage(last_page)}} />
            </Pagination>
        )
    }
}

export default PaginationWidget;